import React, { PureComponent } from 'react';

import CalendarBase from './calendar-base/CalendarBase';
import * as CalendarState from '../../state/reducer/calendar/calendar';
import * as AppState from '../../state/reducer/app/appState';
import { getState, getStore } from '../../state/store';
import loadReactions from '../../v5/messaging/state/loadReactions';

import Console from '../../lib/debug';

export default class TeamCalendarView extends PureComponent {
    constructor(props) {
        super(props);
        this.loadCalendarData(props);
    }

    componentWillUpdate(nextProps) {
        this.loadCalendarData(nextProps);
    }

    getParamsFromProps(props) {
        const programId = parseInt(props.match.params.programId, 10);
        const year = parseInt(props.match.params.year, 10);
        const month = parseInt(props.match.params.month, 10);
        return {
            programId,
            year,
            month
        };
    }

    loadCalendarData(props) {
        const params = this.getParamsFromProps(props);

        const infoTree = getState().calendar.infoTree;

        const isLoaded =
            infoTree.month === params.month && infoTree.year === params.year;

        const programMatch =
            infoTree.programId === params.programId ||
            infoTree.team.id === params.programId;

        if (isLoaded && programMatch) {
            AppState.stopLoading();
            return;
        }

        CalendarState.loadTeamCalendar(
            params.programId,
            params.year,
            params.month
        );
        getStore().dispatch(loadReactions());
    }

    render() {
        Console.render('TeamCalendarView');
        return (
            <CalendarBase
                messagingCallback={() => {
                    const params = this.getParamsFromProps(this.props);
                    CalendarState.loadTeamCalendarSummary(
                        params.programId,
                        params.year,
                        params.month
                    );
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/calendar/TeamCalendarView.jsx